import { authorize, getRequest } from 'utils/http';
import { Environment } from 'global/environment';

export async function getBuildingIdsAPI() {
  return getRequest(`${Environment.BACKEND_API}/search/initial`, await authorize());
}
